module.exports = __webpack_public_path__ + "img/20220622085219.e168f097.png";